import axios from '../axios'

/*
 * 信息类型模块
 */
// 保存
export const save = (data) => {
  return axios({
    url: '/sysParameter/save',
    method: 'post',
    data
  })
};

// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/sysParameter/delete',
    method: 'post',
    data
  })
};

// 列表
export const list = (data) => {
  return axios({
    url: '/sysParameter/list',
    method: 'post',
    data
  })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/sysParameter/view',
    method: 'post',
    data
  })
};

// 编辑,新增
export const edit = (data) => {
  return axios({
    url: '/sysParameter/edit',
    method: 'post',
    data
  })
};

// 获取参数
export const getParam = (data) => {
  return axios({
    url: '/sysParameter/getParameter',
    method: 'post',
    data
  })
};





// WEBPACK FOOTER //
// ./src/http/moudules/sysParameter.js